<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="blog-header-container">
                <div class="row">
                    <div
                        class="col-12 mt-5 pt-5 d-flex justify-content-center align-items-center"
                    >
                        <h2 class="mt-5 pt-5">Crowdsale blog</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <span
                            *ngFor="let category of uniqueCategories"
                            class="badge rounded-pill bg-primary mr-2"
                            style="color: #fff"
                            >{{ category }}</span
                        >
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12 text-center">
                        <button
                            nbButton
                            size="small"
                            status="primary"
                            appearance="ghost"
                            (click)="onBackToCrowdsale()"
                        >
                            BACK TO CROWDSALE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="col-11">
            <div class="row" *ngIf="!blogsNotFound">
                <ngx-article-preview
                    *ngFor="let article of articles; index as i"
                    #article
                    class="col-4"
                    [size]="'small'"
                    [articleData]="article"
                    [contractAddress]="crowdsaleAddress"
                ></ngx-article-preview>
            </div>
            <div class="row mb-5" *ngIf="blogsNotFound">
                <div class="col-12 text-center">
                    <h6>There are no published blogs for this crowdsale!</h6>
                </div>
            </div>
        </div>
    </div>
</div>
